import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';

import DashboardWidget from '../../modules/dashboards/components/dashboard-widget/dashboard-widget.component';

import api from '../api';
import DataTable from '../core/charts/Datatable';
import KendoChart from '../core/charts/KendoChart';
import { converter } from '../core/converter';
import dataBoard from '../core/databoard';
import infoBoard from '../core/infoboard';
import streetView from '../core/map/streetview';
import templates from '../core/templates';
import translate from '../core/tools/translate';
import environment from '../environment';
import { customScrollbar } from '../shared';
import { notify, NOTIFY_TYPE } from '../shared/notify';
import { FeaturePermission } from '../../constants/feature.permission.helper';
import { hidePanelSelectionAlert } from '../../utils';

const LayerControls = (name) => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const _getContainer = (visible = false) =>
    infoBoard.createContainer({
        id: 'info',
        name: 'Profile',
        visible
    });

const showStreeView = (latlng, autostart = false) => {
    streetView.visible(false);
    streetView.show(latlng, true, autostart);
};

const _enlargeImage = (images, latlng, el) =>
    $(el).on('click', e => {
        e.preventDefault();

        const $template = $(templates('stores-image', images));
        const $content = $('#image-container');
        if ($content.is(':visible')) {
            $content.find('.cancel').trigger('click');
        }

        $content.fadeIn(300);
        $content.html($template);

        $template.find('.cancel').on('click', () => $content.empty().hide());

        showStreeView(latlng);
    });

const _drawChart = chart =>
    setTimeout(() => new KendoChart(chart.container, chart.data, chart.options), 300);

const _generateSalesChart = (data, container) => {
    const chart = {
        container,
        data: {
            data: data.sales.chart,
            type: 'area',
            simple: true,
            label: false,
            colors: [
                '#D1D5D8',
                '#3498DB'
            ],
            opacity: 0.75
        },
        options: {
            title: '',
            filename: `${data.name} - ${translate(environment.get("CONFIG.CLIENT_TOTAL_SALES") ? 'Common.AverageMonthlySalesAll' : 'Common.AverageMonthlySales')}`,
            convertTable: true,
            autoheight: true,
            autocoloring: false,
            scrollable: false,
            height: 140,
            buttons: {
                // table: true,
                export: true
            }
        }
    };

    return _drawChart(chart);
};

const _generateSalesBySegments = (data, container) => {
    data.salesBySegments._tables[0].columns = data.salesBySegments._tables[0].columns.reverse();
    const chart = {
        container,
        data: {
            data: data.salesBySegments,
            type: 'bar',
            simple: true,
            label: true,
            opacity: 0.75,
            legend: {
                position: 'bottom',
                visible: true,
                align: 'left',
                orientation: 'vertical'
            }
        },
        options: {
            title: translate(environment.get("CONFIG.CLIENT_TOTAL_SALES") ? 'Common.TotalSalesBySegmentsAll' : 'Common.TotalSalesBySegments'),
            filename: `${data.name} - ${translate(environment.get("CONFIG.CLIENT_TOTAL_SALES") ? 'Common.TotalSalesBySegmentsAll' : 'Common.TotalSalesBySegments')}`,
            convertTable: true,
            height: ((data.salesBySegments.getTotalRows() * 13) * data.salesBySegments.getTotalColumns()) + (16 * data.salesBySegments.getTotalRows())
        }
    };

    return _drawChart(chart);
};

const _generateIndicatorsGrid = (data, container) => {
    const el = document.createElement('div');
    $(container).html(el);

    return new Vue({
        el,
        components: {
            dashboardWidget: DashboardWidget
        },
        data: {
            title: translate('Common.TypesOfServiceAfterSales'),
            filename: `${data.name} - ${translate('Common.TypesOfServiceAfterSales')}`,
            grid: data.services.grid,
            height: 30 + (data.services.grid.length * 96),
            buttons: {
                export: true
            }
        },
        template: `
            <dashboard-widget
                :title="title"
                :filename="filename"
                :buttons="buttons"
                :height="height"
                :grid="grid"/>
            </dashboard-widget>
        `
    });
};

const _generateSalesPerSegmentGrid = (data, container) => {
    const el = document.createElement('div');
    $(container).html(el);

    return new Vue({
        el,
        components: {
            dashboardWidget: DashboardWidget
        },
        data: {
            title: translate(environment.get("CONFIG.CLIENT_TOTAL_SALES") ? 'Common.TotalSales' : 'Common.RetailSales'),
            filename: `${data.name} - ${translate('Common.TotalSales')}`,
            grid: data.sales.grid,
            buttons: {
                export: true
            }
        },
        template: `
            <dashboard-widget
                :title="title"
                :filename="filename"
                :buttons="buttons"
                :grid="grid"/>
            </dashboard-widget>
        `
    });
};

const _generateSalesGrid = (data, container) => {
    const el = document.createElement('div');
    $(container).html(el);

    return new Vue({
        el,
        components: {
            dashboardWidget: DashboardWidget
        },
        data: {
            title: translate(environment.get("CONFIG.CLIENT_TOTAL_SALES") ? 'Common.TotalSales' : 'Common.RetailSales'),
            filename: `${data.name} - ${translate('Common.TotalSales')}`,
            grid: data.sales.grid,
            buttons: {
                export: true
            },
            height: 210,
        },
        template: `
            <dashboard-widget
                :title="title"
                :filename="filename"
                :buttons="buttons"
                :height="height"
                :grid="grid"/>
            </dashboard-widget>
        `
    });
};

class ResumeInfo {
    static getInstance() {
        if (!ResumeInfo._instance) {
            ResumeInfo._instance = new ResumeInfo();
        }

        return ResumeInfo._instance;
    }

    init() {
    }

    show(store, options = {}) {
        const $container = _getContainer((options ? options.visible : false));

        const $content = $(templates('stores-view', { ...store, isClientTotalSales: environment.get("CONFIG.CLIENT_TOTAL_SALES"), title: options.title }));
        $($container).html($content);

        infoBoard.open();

        const headerHeight = $content.find('.panel-group-header').outerHeight();
        if (store.headerClass && headerHeight) {
            $content.find('.panel-group-content').css('margin-top', headerHeight);
        }

        const coordinates = {
            lat: store.location.latitude,
            lng: store.location.longitude
        };

        if (store.image) {
            if (store.image.hasPhoto) {
                const imageLink = $content.find('.store-thumbnail-link');
                _enlargeImage(store.image, coordinates, imageLink);
            } else {
                const imageContainer = $content.find('.store-thumbnail');
                streetView.thumbnail(imageContainer, coordinates);
            }
        }

        setTimeout(() => {
            let chartContainer;
            if (!store.sales || (store.sales.firstPeriod === "-" && store.sales.lastPeriod === "-")) {
                return;
            }

            if ((store.services || {}).grid) {
                chartContainer = $content.find('.chart-services')[0];
                _generateIndicatorsGrid(store, chartContainer);
            }

            if ((store.sales || {}).chart) {
                chartContainer = $content.find('.chart-sales')[0];
                _generateSalesChart(store, chartContainer);
            }

            if (_.size(store.salesBySegments)) {
                chartContainer = $content.find('.chart-sales-by-segment')[0];
                _generateSalesBySegments(store, chartContainer);
            }

            if ((store.sales || {}).grid) {
                chartContainer = $content.find('.table-sales')[0];
                _generateSalesGrid(store, chartContainer);

            }

            if ((store.salesPerSegment || {}).grid) {
                chartContainer = $content.find('.table-sales-segment')[0];
                _generateSalesPerSegmentGrid(store, chartContainer);
            }
        }, 1000);

        if (options.callback) {
            if (store.report) {
                $content.find('#store-action-report').on('click', e => {
                    e.preventDefault();
                    options.callback('reporting');
                });
            }
        }

        $content.find('.store-info-back-button').on('click', e => {
            e.preventDefault();
            hidePanelSelectionAlert();
            options.callbackBack();
        });

        // const actions = infoBoard.createActions({
        //     export: {
        //         value: false,
        //         label: translate('Action.ExportDatasheet')
        //     },
        //     report: {
        //         value: false,
        //         label: translate('Action.ShowReport') // isAuthorized("#{context}-comparison-view")
        //     }
        // }, 'Resume');
        // actions.layout.appendTo($container);
        //
        // $(actions.report).on('click', e => {
        //     e.stopPropagation();
        //     LayerControls('Report').show(0, `${environment.get('NEODASH_HOST')}/report/dealer-summary/dealer-summary?filters=${JSON.stringify({
        //         dealer: store.id,
        //         uf: store.address.UF,
        //         municipio: store.address.Cidade,
        //         ano: moment().format('YYYY'),
        //         mes: moment(environment.get('CONFIG.FILTERS.DATE_PREFERENCES.SUMMARY.END')).format('MMM')
        //     })}&user={user}&apikey={apikey}`);
        // });
        //
        // $(actions.export).on('click', e => {
        //     e.stopPropagation();
        //     const d = {
        //         store: {
        //             title: store.name
        //         },
        //         information: {
        //             title: translate('Common.Information'),
        //             values: _.map(store.information, (v, k) => ({label: k, value: v}))
        //         },
        //         address: {
        //             title: translate('Common.Address'),
        //             values: _.map(store.address, (v, k) => ({label: k, value: v}))
        //         },
        //         indicators: {
        //             title: translate('Common.Indicators'),
        //             values: _.map(store.indicators, (v, k) => ({label: k, value: v}))
        //         },
        //         location: {
        //             title: translate('Common.Location'),
        //             values: _.map(store.location, (v, k) => ({label: k, value: v}))
        //         }
        //     };

        //     if ((store.sales || {}).chart) {
        //         d.sales = {
        //             title: translate('Common.AvgMonthlySalesLast12Months'),
        //             chart: store.sales.chart
        //         };
        //     }
        //
        //     if ((store.sales || {}).grid) {
        //         d.total = {
        //             title: translate('Common.TotalSales'),
        //             grid: store.sales.grid
        //         };
        //     }
        //
        //     if ((store.evaluations || {}).grid) {
        //         d.evaluations = {
        //             title: translate('Common.Evaluation'),
        //             grid: store.evaluations.grid
        //         };
        //     }
        //
        //     if ((store.services || {}).grid) {
        //         d.services = {
        //             title: translate('Common.Attendances'),
        //             grid: store.services.grid
        //         };
        //     }
        //
        //     converter.csv({
        //         name: `${translate('Common.Store')}_${store.name}`,
        //         type: 'store',
        //         data: d
        //     });
        // });

        const groupContent = $content.find('.panel-group-content');
        customScrollbar(groupContent);
    }

    remove() {
        const container = _getContainer();
        infoBoard.dataUnavailable({
            container,
            message: translate('Error.LayerDisabled'),
            image: 'no_data'
        });
        streetView.hide();
    }
}

export default ResumeInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/ResumeInfo.js